import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ADPResourceService } from 'digital-core';
import { ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog-data';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { dashboardRouteWithSlash } from 'src/app/route-constants';

@Component({
  selector: 'pgh-phone-registration',
  templateUrl: './phone-registration.component.html',
  styleUrls: ['./phone-registration.component.scss']
})
export class PhoneRegistrationComponent implements OnInit {
  states = {
    RegisterNumber: 1,
    TextMessage: 2
  }
  state = this.states.RegisterNumber;
  phoneNumber;
  backLabel: string;
  isBackVisible: boolean = false;
  private subscriptions: Subscription[] = [];
  isOnboardingFlow: boolean = false;
  isAdditionalDeviceFlow: boolean = false;
  constructor(
    public resourceService: ADPResourceService,
    private router: Router,
    public route: ActivatedRoute,
    private location: Location,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.backLabel = this.resourceService.getPortaLabelValue("Global_Button_Back");

    this.route.queryParams.subscribe(params => {
      this.isOnboardingFlow = (params.isOnboardingFlow && params.isOnboardingFlow.toLowerCase().trim() === 'true');
    });

    this.route.queryParams.subscribe(params => {
      this.isAdditionalDeviceFlow = (params.isAdditionalDeviceFlow && params.isAdditionalDeviceFlow.toLowerCase().trim() === 'true');
    });
  }

  goToTextScreen(e: any): void {
    this.phoneNumber = e.phoneNumber;
    this.changeState(e.state);
  }
  changeState(state: any): void {
    this.state = state;

    if(state != this.states.TextMessage){
      this.isBackVisible = true;
    }
    else{
      this.isBackVisible = false;
    }

    if (this.state == this.states.RegisterNumber) {
      this.backLabel = this.resourceService.getPortaLabelValue("Global_Button_Back");
    } else {
      this.backLabel = this.resourceService.getPortaLabelValue("RegisterNumber_Back_To_My_Devices");
    }
    this.gotoTop();
  }
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  handleBack() {
    if (this.state == this.states.RegisterNumber) {
      if (window.history.length > 1) {
        this.location.back();
      } else {
        this.router.navigate([this.resourceService.getPortalSetting("URL_MyDevices").Value]);
      }
    } else {
      this.router.navigate([this.resourceService.getPortalSetting("URL_MyDevices").Value]);
    }
  }
  public goToDashboard(){

    let dialogData: ConfirmationDialogData;

    dialogData = {
        title: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Title",
        message: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Message",
        cancelButtonText: "Global_Button_SkipForNow",
        confirmButtonText: "Global_Button_ContinueTest",
        contextData: { titleLeftAligned: false }
      };

    const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
      data: dialogData
    });
    this.subscriptions.push(confirmationDialog.afterClosed().subscribe({
      next: (result) => {
        if (result.toString() === 'false') {
          this.router.navigate([dashboardRouteWithSlash]);
        }
      }
    }));
  }
}
